var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 17C8 15.3432 9.34315 14 11 14C12.6569 14 14 15.3432 14 17V21H8V17Z",
    stroke: "#0092D6",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.00003C1 5.89546 1.89543 5.00003 3 5.00003H5.29844C5.75258 5.00003 6.1932 4.84547 6.54783 4.56177L9.75061 1.99954C10.481 1.41519 11.519 1.41519 12.2494 1.99954L15.4522 4.56177C15.8068 4.84547 16.2474 5.00003 16.7016 5.00003H19C20.1046 5.00003 21 5.89546 21 7.00003V19C21 20.1046 20.1046 21 19 21H3C1.89543 21 1 20.1046 1 19V7.00003Z",
    stroke: "#0092D6",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.00003C13 7.89546 12.1046 7.00003 11 7.00003C9.89543 7.00003 9 7.89546 9 9.00003C9 10.1046 9.89543 11 11 11C12.1046 11 13 10.1046 13 9.00003Z",
    stroke: "#0092D6",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.c13310bca7aa9541cee60938fbfca29d.svg";
export { ForwardRef as ReactComponent };